import { FC } from 'react';
import styles from './styles.module.css';

const SignupCode: FC<{ code?: string }> = props => {
  const { code = '', children } = props;

  // break up the code into pieces
  const parts = code.split('-');

  // in case something goes wrong with incoming data
  if (parts.length !== 2) return <div>{code}</div>;

  // allow custom display using children
  if (children) return <div>{children}</div>;

  return (
    <div className={styles.wrapper}>
      <span className={styles.clinic}>{parts[0]}</span>
      <span className={styles.dash}>&mdash;</span>
      <span className={styles.code}>{parts[1]}</span>
    </div>
  );
};

export default SignupCode;
